import React from 'react';
import {
  Link,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
  List,
  ListItem,
} from '@thebouqs/ui';
import { SFErrorBoundary } from '@/components/ErrorBoundary';
import MenuItemErrorFallback from '@/components/TopNav/MenuItemErrorFallback';
import { SubMenuProps } from './SubMenu.d';

const SubMenu = ({
  topLinkContent,
  topLinkIndex,
  topLinkPath,
  subMenuLinks,
}: SubMenuProps): JSX.Element => {
  return (
    topLinkContent && (
      <SFErrorBoundary
        fallbackComponent={<MenuItemErrorFallback />}
        targetComponent="NavHeader SubMenu">
        <Popover
          isLazy={true}
          lazyBehavior="keepMounted"
          trigger="hover"
          id={`nav-header-menu-item-${topLinkIndex}-submenu`}>
          <PopoverTrigger>
            <Link
              href={topLinkPath}
              display="inline-flex"
              color="text"
              fontWeight="semibold">
              {topLinkContent}
            </Link>
          </PopoverTrigger>
          <PopoverContent
            /* as div because Chakra renders this with a `section` element with `aria-role=tooltip` attribute. That is an a11y violation per Axe */
            as="div"
            alignItems="center"
            width="max"
            fontSize="sm"
            fontWeight="600"
            textAlign="center"
            textTransform="uppercase">
            <PopoverArrow />
            <PopoverBody
              as={List}
              paddingX="8"
              paddingY="4"
              margin="0"
              spacing="4">
              {subMenuLinks.map((item, index) => {
                return (
                  item && (
                    <ListItem
                      key={`nav-header-menu-item-${topLinkIndex}-submenu-item-${index}`}
                      data-testid={`nav-header-menu-item-${topLinkIndex}-submenu-item-${index}`}>
                      <Link href={item.link}>{item.name}</Link>
                    </ListItem>
                  )
                );
              })}
            </PopoverBody>
          </PopoverContent>
        </Popover>
      </SFErrorBoundary>
    )
  );
};

export default SubMenu;
